module.exports = __webpack_public_path__ + "2a3d064b51f4b0a337c5934fd7d17950.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-7.png
// module id = 2200
// module chunks = 0